// tslint:disable:no-http-string
import { Link } from 'gatsby';
import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { SocialLink } from '../../styles/shared';
import config from '../../website-config';
import Instagram from '../icons/instagram';
import SiteNavLogo from './SiteNavLogo';

import { colors } from '../../styles/colors';

const GUIDES_URL = 'https://giggster.com/guide';

const SiteNavStyles = css`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 88px;

  @media (max-width: 650px) {
    min-height: 0;
    padding: 12px 0;
    flex-wrap: wrap;
    justify-content: center;
  }

  a svg {
    transition: transform 0.25s ease-out;
  }

  a:hover svg {
    transform: scale(1.04) rotate(4deg);
  }
`;

const SiteNavLeft = styled.div`
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-scrolling: touch;
  letter-spacing: 0.4px;
  white-space: nowrap;

  @media (max-width: 650px) {
    padding-left: 2vw;
    justify-content: center;
  }
`;

const SiteNavRight = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;

  @media (max-width: 1023px) {
    display: none;
  }
`;

const NavStyles = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
  gap: 24px;

  li {
    display: block;
    margin: 0;
    padding: 0;
    outline: none;
  }

  li a {
    display: block;
    margin: 0;
    color: ${colors.alpha};
    font-size: 16px;
    line-height: 19px;
    letter-spacing: -0.08px;
    font-weight: normal;
    text-decoration: none;
    outline: none;
  }

  li a:hover {
    text-decoration: underline;
  }

  @media (max-width: 430px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    li a { font-size: 14px; line-height: 17px; }
  }
`;

const SocialLinks = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  a:last-of-type {
    padding-right: 0;
  }
  a:first-of-type {
    padding-left: 0;
  }
  svg {
    height: 18px;
    width: 18px;
  }
`;

interface SiteNavProps {
  isHome?: boolean;
}

class SiteNav extends React.Component<SiteNavProps> {
  render() {
    return (
      <nav css={SiteNavStyles}>
        <SiteNavLeft>
          <SiteNavLogo />
          <ul css={NavStyles} role="menu">
            {/* TODO: mark current nav item - add class nav-current */}
            <li role="menuitem">
              <Link to="/photography/">Photography</Link>
            </li>
            <li role="menuitem">
              <a href={`${GUIDES_URL}/movie-location`}>Movies</a>
            </li>
            <li role="menuitem">
              <a href={`${GUIDES_URL}/filming`}>Cities</a>
            </li>
            <li role="menuitem">
              <a href={`${GUIDES_URL}/event`}>Events</a>
            </li>
            <li role="menuitem">
              <a href={`${GUIDES_URL}/reports`}>Reports</a>
            </li>
            <li role="menuitem">
              <a href={`${GUIDES_URL}/composition`}>Composition</a>
            </li>
            <li role="menuitem">
              <a href={`${GUIDES_URL}/portions`}>Portions</a>
            </li>
            <li role="menuitem">
              <Link to="/tools/">Tools</Link>
            </li>
            <li role="menuitem">
              <Link to="/basics/">Basics</Link>
            </li>
            <li role="menuitem">
              <Link to="/gear/">Gear</Link>
            </li>
            <li role="menuitem">
              <Link to="/retouching/">Retouching</Link>
            </li>
          </ul>
        </SiteNavLeft>
        <SiteNavRight>
          <SocialLinks>
            <a
              css={SocialLink}
              href={config.instagram}
              target="_blank"
              title="Instagram"
              rel="noopener noreferrer"
            >
              <Instagram />
            </a>
          </SocialLinks>
        </SiteNavRight>
      </nav>
    );
  }
}

export default SiteNav;
